import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";

export default function useVolunteerKyc() {
  const { baseurl, token, AdminId, setIsUnauthorised } =
    useGlobalContext();

  // const [volunteerKyc, setVolunteerKyc] = useState(null);
  const [loading, setLoading] = useState(false);
const [kycStatusLoading, setKycStatusLoading] = useState(false);
const [volunteerKyc, setVolunteerKyc] = useState([]);
const [volunteerKycList, setVolunteerKycList] = useState([]);

  const fetchVolunteerKycDetails = useCallback(
    async (volunteerId, preserveLocalUpdates = true) => {
      if (!volunteerId) return;

      setLoading(true);

      try {
        const res = await axios.post(
          `${baseurl}/api/VolunteerUser/v1.0/getVolunteerKYCDetails`,
          {
            adminId: AdminId || "",
            volunteerId: volunteerId,
          },
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );

        if (res.data.responseCode === "00") {
          const serverData = res.data.data || null;

          if (!serverData) {
            setVolunteerKyc(null);
            return;
          }

          if (preserveLocalUpdates) {
            setVolunteerKyc((prev) => {
              if (
                prev &&
                ["Approved", "Rejected"].includes(prev.status) &&
                serverData.status === "Pending"
              ) {
                return { ...serverData, status: prev.status };
              }

              return serverData;
            });
          } else {
            setVolunteerKyc(serverData);
          }
        } else if (res.data.responseCode === "401") {
          setIsUnauthorised(true);
        } else {
          toast.error(res.data.responseMessage);
        }
      } catch (err) {
        console.error(err);
        toast.error("Error fetching Volunteer KYC details");
      } finally {
        setLoading(false);
      }
    },
    [baseurl, token, AdminId, setIsUnauthorised]
  );

//   Add Kyc Details 

const submitVolunteerKycStep = useCallback(
  async (stepNumber, formData) => {
    try {
      setLoading(true);

      const payload = {
        adminId: AdminId || "",
        volunteerId:
          formData.volunteer_code ||
          formData.step1?.volunteer_code ||
          formData.step2?.volunteer_code ||
          formData.step3?.volunteer_code ||
          formData.step4?.volunteer_code ||
          "",
        step: stepNumber.toString(),
      };

      if (stepNumber === 1) {
        payload.step1 = {
          city: formData.step1?.city || "",
          area: formData.step1?.area || "",
        };
      }

      if (stepNumber === 2) {
        payload.step2 = {
          profilePicture: formData.step2?.profilePicture || "",
        };
      }

      if (stepNumber === 3) {
        payload.step3 = {
          aadharNumber: formData.step3?.aadharNumber || "",
          aadharFrontPhoto: formData.step3?.aadharFrontPhoto || "",
          aadharBackPhoto: formData.step3?.aadharBackPhoto || "",
        };
      }

      if (stepNumber === 4) {
        payload.step4 = {
          panCard: formData.step4?.panCard || "",
          panCardFrontPhoto: formData.step4?.panCardFrontPhoto || "",
        };
      }

      console.log("FINAL PAYLOAD:", payload);

      const res = await axios.post(
        `${baseurl}/api/VolunteerUser/v1.0/addVolunteerKYCDetails`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.responseCode === "00") {
        return true;
      }

      return false;
    } catch (err) {
      console.error("Volunteer KYC step submit error", err);
      return false;
    } finally {
      setLoading(false);
    }
  },
  [baseurl, token, AdminId]
);

// kyc verify

const handleVolunteerKycAction = async (
  kycId,
  action = "view",
  status = ""
) => {
  setKycStatusLoading(true);

  try {
    const payload = {
      kycId: kycId?.toString() || "",
      kycStatus: action === "view" ? "" : status, // A / R
      adminId: AdminId || "",
    };

    console.log("VERIFY VOLUNTEER KYC PAYLOAD:", payload);

    const res = await axios.post(
      `${baseurl}/api/VolunteerAdmin/v1.0/verifyVolunteeerkycDetails`,
      payload,
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.responseCode === "00") {
      return action === "view"
        ? res.data.data
        : { success: true, message: res.data.responseMessage };
    }

    if (res.data.responseCode === "401") {
      setIsUnauthorised(true);
    }

    throw new Error(
      res.data.responseMessage || "Volunteer KYC action failed"
    );
  } catch (err) {
    toast.error(err.message || "Volunteer KYC action failed");
    throw err;
  } finally {
    setKycStatusLoading(false);
  }
};

// fetchallvolunter kyc details

const fetchAllVolunteerKycDetails = useCallback(async () => {
  try {
    setLoading(true);

    const res = await axios.post(
      `${baseurl}/api/VolunteerAdmin/v1.0/getAllVolunteerKYCDetails`,
      { adminId: AdminId || "" },
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );

    if (res.data.responseCode === "00") {
       setVolunteerKycList(res.data.data || []);
    } else if (res.data.responseCode === "401") {
      setIsUnauthorised(true);
    } else {
      toast.error(res.data.responseMessage);
    }
  } catch (error) {
    toast.error("Error fetching KYC list");
  } finally {
    setLoading(false);
  }
}, [baseurl, token, AdminId, setIsUnauthorised]);



  return {
    volunteerKyc,
    loading,
    kycStatusLoading,
      volunteerKycList,
  fetchVolunteerKycDetails,
  submitVolunteerKycStep,
  fetchAllVolunteerKycDetails,
  handleVolunteerKycAction
  };
}
